import { CarpoolApp, CarpoolAppConf, CountryConf, CountryConfKey } from "@/models/core"

export const COUNTRY_CONF_VALUES = ["fr", "de", "es", "ch", "it", "nl"] as const

const COMPANY_COUNTRY_OPTION_FR = [
    {
        value: "fr",
        label: "France"
    },
    {
        value: "be",
        label: "Belgium"
    },
    {
        value: "ch",
        label: "Switzerland"
    },
    {
        value: "lu",
        label: "Luxembourg"
    },
    {
        value: "re",
        label: "Reunion"
    },
    {
        value: "gp",
        label: "Guadeloupe"
    },
    {
        value: "yt",
        label: "Mayotte"
    },
    {
        value: "es",
        label: "Spain"
    }
]

const COMPANY_COUNTRY_OPTION_DE = [
    {
        value: "de",
        label: "Germany"
    }
]

const COMPANY_COUNTRY_OPTION_ES = [
    {
        value: "es",
        label: "Spain"
    }
]
const COMPANY_COUNTRY_OPTION_CH = [
    {
        value: "ch",
        label: "Switzerland"
    }
]
const COMPANY_COUNTRY_OPTION_IT = [
    {
        value: "it",
        label: "Italy"
    }
]
const COMPANY_COUNTRY_OPTION_NL = [
    {
        value: "nl",
        label: "Netherlands"
    },
    {
        value: "de",
        label: "Germany"
    }
]
export const COMPANY_COUNTRY_OPTION_IDFM = [
    {
        value: "fr",
        label: "France"
    }
]
export const ALL_COUNTRY_OPTIONS = [
    ...COMPANY_COUNTRY_OPTION_FR,
    ...COMPANY_COUNTRY_OPTION_DE,
    ...COMPANY_COUNTRY_OPTION_ES,
    ...COMPANY_COUNTRY_OPTION_IT,
    ...COMPANY_COUNTRY_OPTION_NL
]

export const CARPOOL_APP_INDEX_KAROS: CarpoolApp = 1
export const CARPOOL_APP_INDEX_GOFLUX: CarpoolApp = 3
export const CARPOOL_APP_INDEX_IDFM: CarpoolApp = 4

export const CGU_COUNTRIES_FOR_CARPOOL_APP: Record<CarpoolApp, CountryConfKey[]> = {
    [CARPOOL_APP_INDEX_KAROS]: ["fr", "es", "ch", "it", "nl", "de"],
    [CARPOOL_APP_INDEX_GOFLUX]: ["de"],
    [CARPOOL_APP_INDEX_IDFM]: ["fr"]
}
const DEFAULT_COUNTRY_CONF: Omit<
    CountryConf,
    | "placesApiAuthorizedCountries"
    | "saasEnterpriseUrl"
    | "sassTerritoryUrl"
    | "centerCoords"
    | "countryCenterCoords"
    | "partnerHelpRessourceContext"
    | "appLanguage"
> = {
    gmapsCountryZoom: 6,
    companyCountryOptions: COMPANY_COUNTRY_OPTION_FR,
    deepLinkPrefix: "karos://",
    moneySign: "€",
    currencyCode: "EUR",
    appName: "karos",
    appDisplayName: "Karos",
    primaryColor: "#FF325D",
    gradient: "linear-gradient(90deg, #FF7D63 0%, #FF325D 100%)",
    websiteBridgesUrl: import.meta.env.VITE_WEBSITE_BRIDGES_KAROS,
    displayHomeProductLinks: true,
    carpoolAppIndex: CARPOOL_APP_INDEX_KAROS
}

const COUNTRY_CONFS: Record<CountryConfKey, CountryConf> = {
    fr: {
        ...DEFAULT_COUNTRY_CONF,
        centerCoords: { lat: 48.866667, lng: 2.333333 },
        countryCenterCoords: { lat: 46.227638, lng: 2.213749 },
        placesApiAuthorizedCountries: ["fr", "re", "gp", "yt"],
        partnerHelpRessourceContext: "Context: “Accéder %context_input%“",
        saasEnterpriseUrl: import.meta.env.VITE_SAAS_ENTERPRISE_KAROS,
        sassTerritoryUrl: import.meta.env.VITE_SAAS_TERRITORY_KAROS,
        appLanguage: "fr"
    },
    de: {
        ...DEFAULT_COUNTRY_CONF,
        centerCoords: { lat: 52.5069704, lng: 13.2846503 },
        countryCenterCoords: { lat: 51.165691, lng: 10.451526 },
        placesApiAuthorizedCountries: ["de"],
        companyCountryOptions: COMPANY_COUNTRY_OPTION_DE,
        partnerHelpRessourceContext: "Context: “Zugriff %context_input%“",
        saasEnterpriseUrl: import.meta.env.VITE_SAAS_ENTERPRISE_KAROS_DE,
        sassTerritoryUrl: import.meta.env.VITE_SAAS_TERRITORY_KAROS_DE,
        appLanguage: "de"
    },
    es: {
        ...DEFAULT_COUNTRY_CONF,
        centerCoords: { lat: 42.854732, lng: -2.675213 },
        countryCenterCoords: { lat: 40.406999, lng: -2.213749 },
        gmapsCountryZoom: 7,
        placesApiAuthorizedCountries: ["es"],
        companyCountryOptions: COMPANY_COUNTRY_OPTION_ES,
        partnerHelpRessourceContext: "Context: “Acceso %context_input%“",
        saasEnterpriseUrl: import.meta.env.VITE_SAAS_ENTERPRISE_KAROS_ES,
        sassTerritoryUrl: import.meta.env.VITE_SAAS_TERRITORY_KAROS_ES,
        appLanguage: "es"
    },
    ch: {
        ...DEFAULT_COUNTRY_CONF,
        centerCoords: { lat: 46.801111, lng: 8.226667 },
        countryCenterCoords: { lat: 46.801111, lng: 8.226667 },
        placesApiAuthorizedCountries: ["fr", "ch"],
        companyCountryOptions: COMPANY_COUNTRY_OPTION_CH,
        moneySign: "Fr.",
        currencyCode: "CHF",
        partnerHelpRessourceContext: 'Context: "Access to %context_input%"',
        saasEnterpriseUrl: import.meta.env.VITE_SAAS_ENTERPRISE_KAROS_CH,
        sassTerritoryUrl: import.meta.env.VITE_SAAS_TERRITORY_KAROS_CH,
        appLanguage: "en"
    },
    it: {
        ...DEFAULT_COUNTRY_CONF,
        centerCoords: { lat: 41.1782835, lng: 7.4301835 },
        countryCenterCoords: { lat: 41.1782835, lng: 7.4301835 },
        placesApiAuthorizedCountries: ["it"],
        partnerHelpRessourceContext: "Contesto: “Accesso %context_input%“",
        saasEnterpriseUrl: import.meta.env.VITE_SAAS_ENTERPRISE_KAROS_IT,
        sassTerritoryUrl: import.meta.env.VITE_SAAS_TERRITORY_KAROS_IT,
        appLanguage: "it",
        companyCountryOptions: COMPANY_COUNTRY_OPTION_IT
    },
    nl: {
        ...DEFAULT_COUNTRY_CONF,
        centerCoords: { lat: 52.268178, lng: 5.661993 },
        countryCenterCoords: { lat: 52.268178, lng: 5.661993 },
        placesApiAuthorizedCountries: ["nl", "de"],
        partnerHelpRessourceContext: "Context: “Toegang %context_input%“",
        saasEnterpriseUrl: import.meta.env.VITE_SAAS_ENTERPRISE_KAROS_NL,
        sassTerritoryUrl: import.meta.env.VITE_SAAS_TERRITORY_KAROS_NL,
        appLanguage: "nl"
    }
}

// App-specific overrides for countries (when different from base config)
const COUNTRY_CONF_OVERRIDES: Partial<Record<CarpoolApp, Partial<Record<CountryConfKey, Partial<CountryConf>>>>> = {
    [CARPOOL_APP_INDEX_GOFLUX]: {
        de: {
            appName: "goflux",
            appDisplayName: "goFLUX",
            primaryColor: "#1649BA",
            gradient: "linear-gradient(90deg, #7BB572 0%, #5B8D58 100%)",
            carpoolAppIndex: CARPOOL_APP_INDEX_GOFLUX,
            deepLinkPrefix: "goflux://",
            partnerHelpRessourceContext: "Context: “Zugriff %context_input%“",
            saasEnterpriseUrl: import.meta.env.VITE_SAAS_ENTERPRISE_GOFLUX,
            sassTerritoryUrl: import.meta.env.VITE_SAAS_TERRITORY_GOFLUX,
            websiteBridgesUrl: import.meta.env.VITE_WEBSITE_BRIDGES_GOFLUX,
            appLanguage: "de"
        }
    }
}

export const CARPOOL_APPS: Record<CarpoolApp, CarpoolAppConf> = {
    [CARPOOL_APP_INDEX_KAROS]: { name: "karos", displayName: "Karos" },
    [CARPOOL_APP_INDEX_GOFLUX]: { name: "goflux", displayName: "goFLUX" },
    [CARPOOL_APP_INDEX_IDFM]: { name: "idfm", displayName: "Covoit IDFM" }
}

export const getCountryConf = (country: CountryConfKey, carpoolApp?: CarpoolApp): CountryConf => {
    const baseConf = COUNTRY_CONFS[country]
    if (!carpoolApp) return baseConf

    const override = COUNTRY_CONF_OVERRIDES[carpoolApp]?.[country]
    if (!override) return baseConf

    return { ...baseConf, ...override }
}

export const IDF_POSTAL_CODE_PREFIXES = ["75", "77", "78", "91", "92", "93", "94", "95"]
